import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=4be0de8d&scoped=true&"
import script from "./FormContent.vue?vue&type=script&lang=js&"
export * from "./FormContent.vue?vue&type=script&lang=js&"
import style0 from "./FormContent.vue?vue&type=style&index=0&id=4be0de8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0de8d",
  null
  
)

export default component.exports